const API_URL = process.env.REACT_APP_COUPON_API_URL || '';
const API_KEY = process.env.REACT_APP_COUPON_API_KEY || '';

export interface CouponRedemptionRequest {
  couponCode: string;
  zipCode: string;
}

export interface CouponRedemptionResponse {
  success: boolean;
  message?: string;
  error?: string;
  coupon?: {
    couponCode: string;
    restaurantName: string;
    promotions: string[];
    usedAt: string;
    createdAt: string;
  };
}

export const redeemCoupon = async (request: CouponRedemptionRequest): Promise<CouponRedemptionResponse> => {
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY
      },
      body: JSON.stringify(request)
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to redeem coupon');
    }

    return data;
  } catch (error) {
    console.error('Error redeeming coupon:', error);
    throw error;
  }
};
